<template>
  <div class="page-table-layout" data-testid="information-manager">
    <v-card
      class="all-width flex-card shadow-off"
      loader-height="2"
      :loading="isLoading"
      :disabled="isLoading"
      data-testid="information-manager__main-card"
    >
      <v-card-text class="page-table-layout__body" data-testid="information-manager__main-content">
              <div v-if="!isLoading" class="flex-fill-table">
                <ProjectHeader
                  :description="projectMetadata && projectMetadata.description"
                  :file-loading="fileprocessing['__pbc'] === 1"
                  :can-edit="$nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add')"
                  :has-requests="requestlist.length > 0"
                  :can-add-request="data.stage === 0 && ($nova.hasRight(right, 'add') || $nova.hasRight(right, 'edit'))"
                  :file="pbcfile"
                  :cycle-id="projectMetadata._id"
                  @refresh="refreshData"
                  @download-template="$nova.downloadFile('', {}, '/v2/financialclose/analysis/getinfomanagertemplate')"
                  @download-all="downloadAllRequest"
                  @new-request="addNewRequest"
                  @file-change="pbcfile = $event; bulkReadCSVFile()"
                />

                <div class="d-flex align-center pt-0" v-if="!loading" data-testid="project-view-new__summary-panel">
                  <RequestSummaryCards
                    v-if="!loading || projectMetadata._id"
                    :total-requests="totalrequests"
                    :summary-requested="(data.summary.summary || {}).requested"
                    :summary-pending="(data.summary.summary || {}).pending"
                    :summary-closed="(data.summary.summary || {}).closed"
                    :summary-cancelled="(data.summary.summary || {}).cancelled"
                    :selected-tab="selectedTab"
                    @select-tab="selectedTab = $event"
                  />
                </div>
                <RequestListTable
                  :loading="loading"
                  :paginated-items="paginatedItems"
                  :request-list="requestlistCopy"
                  :headers="tableheaders"
                  :items-per-page="itemsPerPage"
                  :current-page="currentPage"
                  :selected-items.sync="selectItem"
                  :select-filter="selectfilter"
                  :page-details="page_details"
                  :location-list="locationList"
                  :search-query.sync="searchQuery"
                  :original-request-count="requestlist.length"
                  :original-request-list="requestlist"
                  :filter-options-list="requestlistForFilterOptions"
                  :selected-ref-list="formattedRefList"
                  :is-manager="isManager"
                  :table-height="responsiveTableHeight"
                  @action:bulk-edit-owner="addinfoownerdialogBulk = true"
                  @action:info-owner-summary="infoownersummarydialog = true"
                  @update:headers="addTableHeader"
                  @select-all-change="select"
                  @filter-item="filterPart"
                  @clear-item="clearPart"
                  @action:upload="UploadRequest"
                  @action:view-response="(item) => { addeditresponseheader = item; addeditresponse = { response: item.response || '', remark: item.remark || '' }; viewresponsedrawer = true; }"
                  @action:approve="(id) => changeStage(id, 2)"
                  @action:reject="(id) => changeStage(id, 0)"
                  @action:add-edit-response="AddEditResponse"
                  @action:comments="({ item }) => openCommentsDialog(item)"
                  @action:restore="(id) => changeStage(id, 0)"
                  @action:follow-up="sendfollowUP"
                  @action:edit="showEditRequest"
                  @action:cancel="(id) => changeStage(id, -1)"
                  @action:delete="deleteRequest"
                  :summary-email-loading="summaryEmailLoading"
                  @summary-email="summaryEmailSend"
                />
              </div>
              <v-skeleton-loader
                v-else
                type="table-heading, list-item-two-line, article, article table-heading, list-item-two-line, article, article"
                data-testid="project-view-new__loading-skeleton"
              ></v-skeleton-loader>
      </v-card-text>
    </v-card>

    <Pagination 
      ref="paginationComponent"
      :list="requestlistCopy"
      :itemsperpage="itemsPerPage" 
      @paginated-data="setPaginatedData" 
      data-testid="project-view-new__pagination" 
    />

    <RequestFormDrawer
      v-model="addrequestdialog"
      :loading="addrequestloading"
      :request="addeditrequest"
      :errors="addeditrequesterror"
      :info-owner-list="infoownerlist"
      :type-list="typeofrequest"
      :priority-list="prioritylist"
      :category-list="categorylist"
      :location-list="locationList"
      :location-header="$store.state.LocationHeader || 'Location'"
      :min-date="$nova.formatDateISO(new Date())"
      :selected-tasks="selectedTask"
      :task-options="formattedRefList"
      @update-field="$set(addeditrequest, $event.field, $event.value)"
      @update-selected-tasks="selectedTask = $event"
      @update="editRequest()"
      @create="addRequest()"
    />

    <UploadResponseDrawer
      v-model="responsedialog"
      :loading="responseloading"
      :show-tabs="isAddEditResponseMode"
      :request-header="addeditresponseheader"
      :response="addeditresponse"
      :uploaded-files="uploadedfiles"
      :current-user-id="$store.state.user.id"
      :can-add-comments="data.stage === 0 && ($nova.hasRight(right, 'add') || $nova.hasRight(right, 'edit') || $nova.hasRight(right, 'delete'))"
      :comment-text="commentsdata"
      :comment-error="commentserror"
      :comments-loading="commentsloading"
      :user-list="userList"
      @update-files="updateFilesUpload"
      @update-response="addeditresponse[$event.field] = $event.value"
      @remove-file="removeUploadedFile"
      @delete-attachment="handleDeleteAttachment"
      @tab-change="markCommentAsRead(addeditresponseheader); commentsdata = ''; commentserror = ''"
      @update-comment="commentsdata = $event"
      @add-comment="addComment"
      @upload="handleUploadResponse"
      @download-file="$nova.downloadFile($event)"
    />

    <BulkActionInfoOwnerDrawer
      v-model="addinfoownerdialogBulk"
      :loading="addinfoownerdialogBulkloading"
      :selected-count="selectItem.length"
      :info-owner-list="infoownerlist"
      :selected-info-owner="bulkreplaceemail"
      :error="addeditrequesterror.info_owner"
      @update-info-owner="bulkreplaceemail = $event"
      @replace="addInfoOwnerBulk(selectItem, bulkreplaceemail)"
    />

    <InfoOwnerSummaryDrawer
      v-model="infoownersummarydialog"
      :summary-list="Array.isArray(infoownersummarylist) ? { list: infoownersummarylist } : infoownersummarylist"
      :has-edit-rights="$nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add') || $nova.hasRight(right, 'delete')"
      @send-mail="sendMail"
    />

    <ViewResponseDrawer
      v-model="viewresponsedrawer"
      :request-header="addeditresponseheader"
      :response="addeditresponse"
      :current-user-id="$store.state.user.id"
      :can-add-comments="data.stage === 0 && ($nova.hasRight(right, 'add') || $nova.hasRight(right, 'edit') || $nova.hasRight(right, 'delete'))"
      :comment-text="commentsdata"
      :comment-error="commentserror"
      :comments-loading="commentsloading"
      :user-list="userList"
      @open-comments="markCommentAsRead(addeditresponseheader); commentsdata = ''; commentserror = ''"
      @download-file="$nova.downloadFile($event)"
      @update-comment="commentsdata = $event"
      @add-comment="addComment"
    />

    <lb-comment
      ref="commentsDrawer"
      v-model="commentsdialog"
      hide-trigger
      heading="Comments"
      :comments="addeditresponseheader.comments || []"
      :user-list="userList"
      :send-loading="commentsloading"
      :send-error="commentserror"
      :closed="commentsDrawerReadOnly"
      @send="addComment"
    />

    <BulkUploadDrawer
      v-model="pbcdialog"
      :upload-data="pbcuploaddata"
      :loading="pbcloading"
      :error-flag="pbcerrorflag"
      :error-list="pbcerrorlist"
      :headers="csvTableHeaders"
      :file-upload-flag="fileUploadTypes.FILE_UPLOAD"
      @verify-upload="uploadPbcData"
    />

    <SummaryEmailDialog
      v-model="summaryEmailDialog"
      :loading="summaryEmailLoading"
      :suggested-contacts="emailSuggestions"
      :info-owner-list="infoownerlist"
      :email-template="storeEmailSummaryTemplate"
      :selected-items="selectItem"
      :project-name="(data && data.summary && data.summary.name) || (data && data.name) || ''"
      :user-name="$store.state.user.name || ''"
      :user-email="$store.state.user.email || ''"
      @send="sendSummaryEmail"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { readCSVClient } from '../../../utils/utils';
import {
  IM_FILE_UPLOAD_TYPES,
  IM_CSV_TABLE_HEADERS,
  REQUEST_TYPES,
  INFORMATION_MANAGER_TABLE_HEADERS,
  INFORMATION_MANAGER_STAGE_LABEL_MAP,
  INFORMATION_MANAGER_PRIORITY_LIST,
  INFORMATION_MANAGER_TYPE_OPTIONS,
} from '../../../utils/constants';
import { resolveStageLabel, buildRequestUpdatePayload, resolveLocationName, validateInformationRequest, calculateDueDateDays } from '../../../utils/informationManager';
import {
  prepareRequestsForUpdate,
  buildInfoOwnerSummary,
  buildBulkUploadTemplateRows,
  buildRequestExportRows,
  buildCsvDataUri,
} from '../../../utils/informationManagerComponentUtils';
import ProjectHeader from './components/ProjectHeader.vue';
import RequestSummaryCards from './components/RequestSummaryCards.vue';
import RequestFormDrawer from './components/RequestFormDrawer.vue';
import UploadResponseDrawer from './components/UploadResponseDrawer.vue';
import BulkUploadDrawer from './components/BulkUploadDrawer.vue';
import InfoOwnerSummaryDrawer from './components/InfoOwnerSummaryDrawer.vue';
import BulkActionInfoOwnerDrawer from './components/BulkActionInfoOwnerDrawer.vue';
import ViewResponseDrawer from './components/ViewResponseDrawer.vue';
import Pagination from '@/modules/financialclose/components/Pagination/Pagination.vue';
import RequestListTable from './components/RequestListTable.vue';
import SummaryEmailDialog from './components/SummaryEmailDialog.vue';

const LOG_PREFIX = '[InformationManager]:';

export default {
  name: 'financialclose_project_informationmanager',
  components: {
    ProjectHeader,
    RequestSummaryCards,
    RequestFormDrawer,
    UploadResponseDrawer,
    BulkUploadDrawer,
    InfoOwnerSummaryDrawer,
    BulkActionInfoOwnerDrawer,
    ViewResponseDrawer,
    Pagination,
    RequestListTable,
    SummaryEmailDialog,
  },
  data() {
    const stageLabelMap = { ...INFORMATION_MANAGER_STAGE_LABEL_MAP };
    return {
      windowHeight: window.innerHeight,
      right: 'financialclose_pbc_request',
      fileprocessing: {},
      pbcfile: null,
      pbcdialog: false,
      pbcerrorflag: false,
      pbcuploaddata: [],
      pbcerrorlist: [],
      routeProjectId: '',
      selectedTask: [],
      id: '',
      isFree: true,
      stageLabelMap,
      requesttype: { ...REQUEST_TYPES },
      addeditrequest: { reference: [],},
      addeditrequesterror: {},
      addeditresponseheader: {},
      addeditresponse: {},
      addeditresponseerror: {},
      isAddEditResponseMode: true,
      bulkreplaceemail:'',
      statusloading: {},
      sendmailloading: false,
      addrequestdialog: false,
      addrequestloading: false,
      addinfoownerdialogBulk:false,
      addinfoownerdialogBulkloading:false,
      responsedialog: false,
      responseloading: false,
      commentsdialog: false,
      commentsloading: false,
      commentsdata: "",
      commentserror: "",
      closeprojectloading: false,
      openprojectloading: false,
      infoownersummarydialog: false,
      infoownersummaryloading: false,
      loading: false,
      requestlistCopy:[],
      activeFilter: null,
      currentPage: 1,
      tableheaders: INFORMATION_MANAGER_TABLE_HEADERS(stageLabelMap),
      searchQuery: "",
      itemsPerPage: 12,
      paginatedItems: [],
      selectedTab: null,
      selectItem: [],
      uploadedfiles: null,
      viewresponsedrawer:false,
      typeofrequest: INFORMATION_MANAGER_TYPE_OPTIONS.map(option => ({ ...option })),
      prioritylist: [...INFORMATION_MANAGER_PRIORITY_LIST],
      pbcloading: false,
      selectfilter: {},
      page_details: {},
      summaryEmailLoading: false,
      summaryEmailDialog: false,
      emailSuggestions: [],
    };
  },
  computed: {
    // Use correct Vuex namespace for informationManager module
    ...mapGetters('informationManager', {
      isLoading: 'isLoading',
      uploadLoading: 'isUploadLoading',
      projectMetadata: 'projectMetadata',
      storeUserList: 'userList',
      storeRequestList: 'requestList',
      storeInfoOwnerList: 'infoOwnerList',
      storeLocationList: 'locationList',
      storeFilteredLocationList: 'filteredLocationList',
      storeProjectSummary: 'projectSummary',
      storeEmailSummaryTemplate: 'emailSummaryTemplate',
      completeChecklist: 'completeChecklist',
    }),
    // Compatibility computed properties
    requestlist() {
      return this.storeRequestList || [];
    },
    infoownerlist() {
      return this.storeInfoOwnerList || [];
    },
    locationList() {
       return this.storeFilteredLocationList && this.storeFilteredLocationList.length
         ? this.storeFilteredLocationList
         : (this.storeLocationList || []);
    },
    data() {
      return {
        ...this.projectMetadata,
        summary: this.storeProjectSummary
      };
    },
    owners() {
      const owners = {};
      const requests = this.requestlist;
      for (let i = 0; i < requests.length; i++) {
        const el = requests[i];
        if (el.info_owner) {
          owners[el.info_owner] = owners[el.info_owner] || {};
        }
      }
      let colors = this.$nova.getColors(Object.keys(owners).length, 0.5);
      for (let i = 0; i < Object.keys(owners).length; i++) {
        const el = Object.keys(owners)[i];
        owners[el].color = colors[i];
      }
      return owners;
    },
    categorylist() {
      const categories = ["Others"];
      const requests = this.requestlist;
      for (let i = 0; i < requests.length; i++) {
        const el = requests[i];
        if (el.category && el.category !== "") {
          if (categories.indexOf(el.category) === -1) categories.push(el.category);
        }
      }
      return categories;
    },
    isManager() {
      const userId = this.$store.state.user?.id || this.$store.state.user?._id || '';
      const pbcManagerList = this.storeProjectSummary?.managerlist || [];
      const projectManagerList = this.projectMetadata?.managerlist || [];
      return pbcManagerList.some(id => id?.toString() === userId?.toString())
        || projectManagerList.some(id => id?.toString() === userId?.toString());
    },
    fileUploadTypes() {
      return IM_FILE_UPLOAD_TYPES;
    },
    formattedRefList() {
      // Derive unique task references from enriched requests (v3 referenceChecklist)
      const map = new Map();
      (this.storeRequestList || []).forEach(req => {
        (req.referenceChecklist || []).forEach(cl => {
          if (cl._id && !map.has(cl._id)) {
            map.set(cl._id, { value: cl._id, name: cl.description, master_id: cl.master_id, ref: cl.ref, location: cl.location });
          }
        });
      });
      return Array.from(map.values());
    },
    completeRefList() {
      // Format complete checklist for CSV validation - includes ALL checklist items, not just referenced ones
      const map = new Map();
      (this.completeChecklist || []).forEach(cl => {
        if (cl._id && !map.has(cl._id) && cl.ref) {
          const locationName = cl.__computed?.locationName || '';
          map.set(cl._id, {
            value: cl._id,
            name: cl.description,
            master_id: cl.master_id,
            ref: cl.ref,
            location: cl.location,
            locationName: locationName
          });
        }
      });
      return Array.from(map.values());
    },
    userList() {
      return this.storeUserList || [];
    },
    referenceCodes() {
      return this.formattedRefList.map(item => item.ref).filter(Boolean);
    },
    totalrequests() {
      if (this.data?.summary?.summary) {
        return this.data.summary.summary.total || 0;
      }
      return 0;
    },
    progress() {
      if (this.totalrequests === 0) return 0;
      if (this.data && this.data.summary && this.data.summary.summary) {
        const summary = this.data.summary.summary;
        const completed = (summary.approved || 0) + (summary.cancelled || 0);
        return ((completed / this.totalrequests) * 100).toFixed(0);
      }
      return 0;
    },
    pendingmail() {
      let count = 0;
      for (let i = 0; i < this.requestlist.length; i++) {
        const el = this.requestlist[i];
        if (el.mail_count === 0 && el.stage === 0) count++;
      }
      return count;
    },
    infoownerlistids() {
      const ids = {};
      for (let i = 0; i < this.infoownerlist.length; i++) {
        const el = this.infoownerlist[i];
        ids[el._id] = el;
      }
      return ids;
    },
    infoownersummarylist() {
      return buildInfoOwnerSummary(this.requestlist);
    },
    
    // Merged computed from ProjectView.vue
    csvTableHeaders() {
      return IM_CSV_TABLE_HEADERS;
    },
    requesttypedropdown: function () {
      let r = [];
      for (const k in this.requesttype) {
        if (Object.hasOwnProperty.call(this.requesttype, k)) {
          const el = this.requesttype[k];
          r.push({ name: el, value: k });
        }
      }
      return r;
    },
    getLocationName() {
      return (id) => resolveLocationName(id, this.locationList);
    },
    getlocationById() {

      return (id) => {


        if (typeof id === 'string') {
          let taskdetail = this.formattedRefList.filter(loc => loc.value === id);
          if (taskdetail) {
            taskdetail = this.getRefById(taskdetail.value)
          }
          return taskdetail ? taskdetail.location : '';
        }
        if (typeof id === 'object' && Object.keys(id).includes('location')) {
          let locationID = this.getLocationName(id?.location)

          return locationID ? locationID : 'NA';
        }
      };
    },
    getNameById() {

      return (id) => {
        const taskdetail = this.formattedRefList.find(loc => loc.value === id || loc.master_id === id);
        return taskdetail ? taskdetail.name : 'NA';
      };
    },
    getRefById() {
      return (id) => {
        const reference = this.formattedRefList.find(loc => loc.value === id || loc.master_id === id);
        return reference ? reference : 'NA';
      };
    },
    getUserById() {
      return (id) => {
        const name = this.userList.find(loc => loc._id === id );  
        return  name ? name.name :'NA';
      };
    },
    /**
     * Builds a map of location ID → location name for the "Location" filter dropdown.
     */
    locationLabelMap() {
      const map = {};
      (this.locationList || []).forEach(loc => {
        if (loc._id && loc.name) {
          map[loc._id] = loc.name;
        }
      });
      return map;
    },
    /**
     * Fixed table height for Information Manager view.
     */
    responsiveTableHeight() {
      return 'calc(100vh - 380px)';
    },
    /** Hide comment input in lb-comment when project/request stage disallows comments */
    commentsDrawerReadOnly() {
      const canAdd = this.data.stage === 0
        && (this.$nova.hasRight(this.right, 'add')
          || this.$nova.hasRight(this.right, 'edit')
          || this.$nova.hasRight(this.right, 'delete'));
      const requestStage = this.addeditresponseheader?.stage;
      const disabledStage = requestStage === -1 || requestStage === 2;
      return !canAdd || disabledStage;
    },
    /**
     * Stage-scoped request list for column filter option lists.
     * Excludes column filters so checkbox values stay complete after Apply.
     */
    requestlistForFilterOptions() {
      let list = this.requestlist ? this.requestlist.map(item => ({ ...item })) : [];
      this.enrichRequestList(list);
      if (this.selectedTab !== null) {
        list = list.filter(req => req.stage === this.selectedTab);
      }
      return list;
    },
  },
  created() {
    this.initializeComponent();
    window.addEventListener('resize', this.handleResize);
  },
  activated() {
    this.refreshData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.resetLocalState();
    this.resetChecklistCache();
    this.resetState();
  },
  methods: {
    // Use correct Vuex namespace for informationManager module
    ...mapActions('informationManager', [
      'fetchProjectContext',
      'resetState',
      'fetchRequests',
      'fetchAllChecklist',
      'changeRequestStage',
      'closeProject',
      'openProject',
      'addRequest',
      'editRequest',
      'deleteRequest',
      'updateResponse',
      'bulkUpdateInfoOwner',
      'addInfoOwner',
      'editInfoOwner',
      'addComment',
      'markCommentAsRead',
      'sendMail',
      'bulkUploadPbc',
      'fetchEmailSuggestions',
      'triggerEmailSummary',
    ]),
    /**
     * Enriches a request list clone with computed fields required for filtering.
     * - duedate_days: computed integer (days remaining or overdue) from duedate ISO string
     * @param {Array} list - Already-cloned array of request items
     * @returns {Array} Same array with duedate_days added to each item
     */
    enrichRequestList(list) {
      list.forEach(item => {
        const days = calculateDueDateDays(item.duedate);
        item.duedate_days = (days === '' || days === undefined || days === null) ? null : Number(days);
        // Flatten referenceChecklist ref codes into an array for select filtering
        item.ref = (item.referenceChecklist || []).map(r => r.ref).filter(Boolean);
        // Flatten info_owner name for filtering
        item.info_owner_name = (item.info_owner_detail || {}).name || '';
        // Flatten requested-by name for filtering (matches table N/A display)
        item.created_by_name = (item.created_by_detail && item.created_by_detail.name)
          ? item.created_by_detail.name
          : 'N/A';
      });
      return list;
    },
    /**
     * Handle window resize to update responsive table height
     */
    handleResize() {
      this.windowHeight = window.innerHeight;
    },
    /**
     * Applies the locationLabelMap to the "Location" header
     * so the filter dropdown shows location names instead of raw IDs.
     */
    updateLocationLabelMap() {
      const header = this.tableheaders.find(h => h.value === 'location');
      if (header) {
        this.$set(header, 'filterLabelMap', this.locationLabelMap);
      }
    },
    // Load the Information Manager context for the active project.
    async initializeComponent() {
      const projectId = this.$route.params.id || '';
      this.routeProjectId = projectId;
      if (!projectId) {
        this.$store.commit('sbError', 'Project id missing for Information Manager view');
        return;
      }
      try {
        await this.fetchProjectContext({ projectId });
        this.refreshData();
      } catch (error) {
        console.log(LOG_PREFIX, 'Initialization failed', error);
      }
    },
    // Clear transient local state when leaving the view.
    resetLocalState() {
      // Reset all component data to initial state
      const stageLabelMap = { ...INFORMATION_MANAGER_STAGE_LABEL_MAP };
      this.fileprocessing = {};
      this.pbcfile = null;
      this.pbcdialog = false;
      this.pbcerrorflag = false;
      this.pbcuploaddata = [];
      this.pbcerrorlist = [];
      this.routeProjectId = '';
      this.selectedTask = [];
      this.id = '';
      this.isFree = true;
      this.stageLabelMap = stageLabelMap;
      this.requesttype = { ...REQUEST_TYPES };
      this.addeditrequest = { reference: [] };
      this.addeditrequesterror = {};
      this.addeditresponseheader = {};
      this.addeditresponse = {};
      this.addeditresponseerror = {};
      this.isAddEditResponseMode = true;
      this.bulkreplaceemail = '';
      this.statusloading = {};
      this.sendmailloading = false;
      this.addrequestdialog = false;
      this.addrequestloading = false;
      this.addinfoownerdialogBulk = false;
      this.addinfoownerdialogBulkloading = false;
      this.responsedialog = false;
      this.responseloading = false;
      this.commentsdialog = false;
      this.commentsloading = false;
      this.commentsdata = '';
      this.commentserror = '';
      this.closeprojectloading = false;
      this.openprojectloading = false;
      this.infoownersummarydialog = false;
      this.infoownersummaryloading = false;
      this.loading = false;
      this.requestlistCopy = [];
      this.activeFilter = null;
      this.currentPage = 1;
      this.tableheaders = INFORMATION_MANAGER_TABLE_HEADERS(stageLabelMap);
      this.searchQuery = '';
      this.itemsPerPage = 12;
      this.paginatedItems = [];
      this.selectedTab = null;
      this.selectItem = [];
      this.uploadedfiles = null;
      this.viewresponsedrawer = false;
      this.typeofrequest = INFORMATION_MANAGER_TYPE_OPTIONS.map(option => ({ ...option }));
      this.prioritylist = [...INFORMATION_MANAGER_PRIORITY_LIST];
      this.pbcloading = false;
      this.selectfilter = {};
      this.page_details = {};
    },
    resetChecklistCache() {
      this.$store.commit('informationManager/SET_COMPLETE_CHECKLIST', []);
    },
    
    // Merged methods from ProjectView.vue
    getStageLabel(stage) {
      return resolveStageLabel(stage, this.stageLabelMap);
    },
    openUploadDialog(item) {
      this.isAddEditResponseMode = false; // Upload from table - hide tabs
      this.responsedialog = true;
      this.addeditresponseheader = item;
      this.addeditresponse = { response: item.response || '', remark: item.remark || '' };
      this.uploadedfiles = [];
    },
    openCommentsDialog(item) {
      this.markCommentAsRead(item);
      this.commentsdialog = true;
      this.addeditresponseheader = item;
      this.commentsdata = '';
      this.commentserror = '';
    },
    AddEditResponse(item) {
      this.isAddEditResponseMode = true; // Add/Edit mode - show tabs
      this.responsedialog = true;
      this.addeditresponseheader = item;
      this.addeditresponse = { response: item.response || '', remark: item.remark || '' };
    },
    UploadRequest(item) {
      this.isAddEditResponseMode = false; // Upload mode - hide tabs
      this.responsedialog = true;
      this.addeditresponseheader = item;
      this.addeditresponse = { response: item.response || '', remark: item.remark || '' };
      this.uploadedfiles = [];
    },
    /**
     * Remove a file from the uploaded files array by index
     * @param {number} index - The index of the file to remove
     */
    removeUploadedFile(index) {
      if (Array.isArray(this.uploadedfiles) && index >= 0 && index < this.uploadedfiles.length) {
        this.uploadedfiles.splice(index, 1);
      }
    },
    /**
     * Handle deletion of attachment files from existing responses
     * @param {Object} file - The file object to delete
     * @param {number} fileIdx - The index of the file
     */
    handleDeleteAttachment(file, fileIdx) {
      this.$store.commit('sbError', 'Delete attachment functionality not implemented. Please contact the development team.', { root: true });
      console.log(`[InformationManager]: Delete attachment requested for file:`, file, `at index:`, fileIdx);
      // TODO: Implement store action for deleting attachments from information manager requests
      // Once implemented, call: this.$store.dispatch('informationManager/deleteAttachment', { requestId: this.addeditresponseheader._id, fileId: file._id })
    },
    showEditRequest(item) {
      item.fileupload = (['fileupload', 'fileuploadtolink'].indexOf(item.type) > -1) ? true : false;
      this.addrequestdialog = true;
      this.addeditrequest = { ...item };
      this.addeditrequesterror = {};
      this.selectedTask = this.addeditrequest.reference;
    },
    bulkReadCSVFile(){
      this.readPbcFile('__pbc');
      this.pbcuploaddata = [];
      this.pbcdataerror = [];
      this.pbcerrorlist = [];
      this.fileprocessing['__pbc'] = 0;
    },
     async readPbcFile(processKey) {
      const file = this.pbcfile;
      if (!(file && file.name) || this.fileprocessing[processKey]) return;
      this.fileprocessing[processKey] = 1;
      
      try {
        // Fetch all checklist items for CSV validation (cached in store)
        await this.fetchAllChecklist({ projectId: this.$route.params.id });
        const { pbcuploaddata, pbcdataerror, pbcerrorlist, errorFlag } = await readCSVClient(
          file,
          this.completeRefList,
          this.$nova.readExcelFile.bind(this.$nova)
        );
        this.pbcuploaddata = pbcuploaddata;
        this.pbcdataerror = pbcdataerror;
        this.pbcerrorlist = pbcerrorlist;
        this.pbcerrorflag = errorFlag;
        this.pbcdialog = true;
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Not able to read CSV file");
        console.log(err);
      } finally {
        this.fileprocessing[processKey] = 0;
        this.pbcfile = null;
      }
    },
    uploadPbcData(){
      this.pbcloading = true;
      let ndt = [];
      for (const i of this.pbcuploaddata) {
        ndt.push(i.data[0]);
      }
      this.bulkUploadPbc({
        projectId: this.projectMetadata._id,
        items: ndt
      }).then((status) => {
        if (status === 'success') {
          this.pbcdialog = false;
          this.refreshData();
        }
      }).catch(err => {
        this.$store.commit("sbError", err?.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.pbcloading = false;
      });
    },
    
    isSelected(item) {
      // Check if the item is in `addeditrequest.selectlist`
      return this.addeditrequest?.selectlist?.some(
        selected => selected.selectlist === item.master_id && selected.location === item.location
      );
    },

    updateFilesUpload(filesss) {
      this.uploadedfiles = filesss
    },
    refreshData() {
      if (this.$route.hash === "#add") {
        this.addNewRequest();
      }

     if ((this.$store.state.subscriptions.pbc?.plan_detail?.code === 'pbc_free')) this.isFree = true;
      else this.isFree = false;

      // Use projectMetadata.pbcproject as id
      if (this.projectMetadata && this.projectMetadata.pbcproject) {
        this.id = this.projectMetadata.pbcproject;
      }
      // Force refresh form data (users/locations) like Tasklist does
      this.$store.dispatch('tasks/fetchFormDataV3', { forceRefresh: true });
      return this.getData();
    },
    getData() {
      this.loading = true;
      return this.fetchRequests({ projectId: this.id })
        .then(() => {
          // requestlistCopy is updated automatically by the requestlist watcher
          // totalrequests, progress, pendingmail, infoownerlistids, and infoownersummarylist are now computed properties
          this.loading = false;
          if (this.projectMetadata && this.projectMetadata.pbcproject) {
            this.id = this.projectMetadata.pbcproject;
          }
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStage(id, s) {
      this.statusloading[id] = true;
      this.changeRequestStage({ requestId: id, stage: s })
        .then(() => {
          // fetchRequests is called by the action
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.statusloading[id] = false;
        });
    },
    addNewRequest() {
      this.addrequestdialog = true;
      this.addeditrequest = {};
      this.addeditrequesterror = {};
      this.selectedTask = [];
    },
    closeProject() {
      this.closeprojectloading = true;
      this.$store.dispatch('informationManager/closeProject', { projectId: this.id })
        .then(() => {
          // fetchRequests is called by the action
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.closeprojectloading = false;
        });
    },
    openProject() {
      this.openprojectloading = true;
      this.$store.dispatch('informationManager/openProject', { projectId: this.id })
        .then(() => {
          // fetchRequests is called by the action
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.openprojectloading = false;
        });
    },
    addRequest() { 
      const { errors, hasError } = validateInformationRequest(this.addeditrequest);
      this.addeditrequesterror = errors;
      if (hasError) {
        this.$store.commit("sbError", "Please fill all required fields correctly.");
        return;
      }
      this.addrequestloading = true;
      this.addeditrequest.reference = this.selectedTask;
      const [normalizedRequest] = prepareRequestsForUpdate(
        [{ ...this.addeditrequest }],
        { projectId: this.id, cycleId: this.projectMetadata._id, isFreePlan: this.isFree },
      );
      if (normalizedRequest) {
        Object.assign(this.addeditrequest, normalizedRequest);
      }
      const requestBatch = normalizedRequest ? [normalizedRequest] : [];
      
      this.$store.dispatch('informationManager/addRequest', { data: requestBatch })
        .then(() => {
          this.addeditrequest = {};
          this.addrequestdialog = false;
          // fetchRequests is called by the action
        })
        .catch(err => {
          if (err.data && err.data.length > 0) {
            if (err.data[0].index0) this.addeditrequesterror = err.data[0].index0;
          }
        })
        .finally(() => {
          this.addrequestloading = false;
        })
    },
    editRequest() {
      const { errors, hasError } = validateInformationRequest(this.addeditrequest);
      this.addeditrequesterror = errors;
      if (hasError) {
        this.addrequestloading = false;
        return;
      }
      this.addrequestloading = true;
      this.addeditrequest.reference = this.selectedTask;
      if (!this.addeditrequest.category || (Array.isArray(this.addeditrequest.category) && this.addeditrequest.category.length === 0)) {
        this.addeditrequest.category = '';
      }
      const [normalizedRequest] = prepareRequestsForUpdate(
        [{ ...this.addeditrequest }],
        { projectId: this.id, isFreePlan: this.isFree },
      );
      if (normalizedRequest) {
        Object.assign(this.addeditrequest, normalizedRequest);
      }
      const payload = buildRequestUpdatePayload(this.addeditrequest);
      this.$store.dispatch('informationManager/editRequest', { requestId: payload._id, data: payload })
        .then(() => {
            this.addrequestdialog = false;
            this.addeditrequest = {};
            // fetchRequests is called by the action
          })
        .catch(err => {
            if (err.data && err.data.length > 0) {
              if (err.data[0].index0) this.addeditrequesterror = err.data[0].index0;
            }
        })
        .finally(() => {
          this.addrequestloading = false;
          this.addrequestdialog=false
        })
    },
    deleteRequest(id) {
      this.$store.dispatch('informationManager/deleteRequest', { requestId: id , cycleId: this.projectMetadata._id })
        .then(() => {
          // fetchRequests is called by the action
        })
        .catch(err => console.log(err))
    },
    async handleUploadResponse() {
      if (!this.addeditresponseheader?._id) {
        return;
      }

      // Validate based on request type
      const requestType = this.addeditresponseheader.type;
      const files = Array.isArray(this.uploadedfiles) ? this.uploadedfiles : [];
      const responseText = this.addeditresponse?.response;

      if (requestType === 'fileupload') {
        if (files.length === 0) {
          this.$store.commit('sbError', 'Please upload at least one file', { root: true });
          return;
        }
      } else if (requestType === 'text') {
        if (!responseText || !responseText.trim()) {
          this.$store.commit('sbError', 'Please provide a response', { root: true });
          return;
        }
      }

      this.responseloading = true;
      const filesToUpload = requestType === 'fileupload' && files.length > 0 ? [...files] : [];

      try {
        await this.updateResponse({
          requestId: this.addeditresponseheader._id,
          data: this.addeditresponse,
          files: filesToUpload,
          client: this.$store.state.client,
        });
        this.responsedialog = false;
        this.uploadedfiles = [];
        // fetchRequests is called by the action
      } catch (error) {
        if (error?.data && error.data.length > 0 && error.data[0].index0) {
          this.addeditresponseerror = error.data[0].index0;
        }
        console.log('[InformationManager]: handleUploadResponse error', error);
      } finally {
        this.responseloading = false;
      }
    },
    addInfoOwnerBulk(tasks,email){
      this.addinfoownerdialogBulkloading = true;
      let data = [{ lineids:tasks ,info_owner:email}];
      
      this.$store.dispatch('informationManager/bulkUpdateInfoOwner', { projectId: this.id, data })
        .then(() => {
          this.addinfoownerdialogBulk = false;
          this.selectItem = [];
          // fetchRequests is called by the action
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.addinfoownerdialogBulkloading = false;
          this.addinfoownerdialogBulk = false;
        });
    },
    addComment(message) {
      const text = (message || this.commentsdata || '').trim();
      if (!text) {
        return;
      }
      this.commentsloading = true;
      this.$store.dispatch('informationManager/addComment', { 
          projectId: this.id, 
          data: [{ comment: text, request: this.addeditresponseheader._id || '' }] 
      })
        .then(() => {
            this.commentsdata = '';
            this.commentserror = '';
            if (this.$refs.commentsDrawer) {
              this.$refs.commentsDrawer.resetMessage();
            }
            // Refresh request data to show new comment
            return this.fetchRequests({ projectId: this.id });
        })
        .then(() => {
          // requestlistCopy is updated automatically by the requestlist watcher
          // Update the current header with refreshed data
          const updatedRequest = this.requestlist.find(r => r._id === this.addeditresponseheader._id);
          if (updatedRequest) {
            this.addeditresponseheader = updatedRequest;
          }
        })
        .catch(err => {
           if (err.data && err.data.length > 0 && err.data[0].index0) {
             this.commentserror = err.data[0].index0;
           }
           console.log(err);
        })
        .finally(() => {
          this.commentsloading = false;
        });
    },
    markCommentAsRead(x) {
      if ((x.comments || []).length > 0) {
        let commentkey = x.comments.length - 1;
        let comment = x.comments[commentkey];
        if ((comment.readby || []).indexOf(this.$store.state.user.id) === -1) {
          this.$store.dispatch('informationManager/markCommentAsRead', { requestId: x._id })
            .catch(err => console.log(err));
        }
      }
    },
    sendMail(t = "", info_owner = "") {
      let ndt = {};
      if (t === 'reminder') {
        ndt.info_owner = [info_owner]
        ndt.type = "reminder";
      }
      this.sendmailloading = true;
      this.infoownersummaryloading = true;
      
      this.$store.dispatch('informationManager/sendMail', { projectId: this.id, data: [ndt] })
        .then(() => {
          // fetchRequests is called by the action
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.sendmailloading = false;
          this.infoownersummaryloading = false;
        });
    },
    /**
     * Utility to trigger a CSV file download in the browser
     * @param {string} csvContent - The CSV content as a data URI
     * @param {string} filename - The filename for the download
     */
    triggerCsvDownload(csvContent, filename) {
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    downloadBulkUploadTemplate() {
      const csvContent = buildCsvDataUri(buildBulkUploadTemplateRows());
      this.triggerCsvDownload(csvContent, 'bulk_request_template.csv');
    },
    downloadAllRequest() {
      const projectDueDateLabel = this.data?.duedate ? this.$nova.formatDate(new Date(this.data.duedate)) : '';
      const csvRows = buildRequestExportRows({
        projectName: this.data?.name || '',
        projectDueDate: projectDueDateLabel,
        requests: this.requestlist,
        getLocationName: this.getLocationName,
        getStageLabel: (stage) => this.getStageLabel(stage),
        formatDate: (value) => this.$nova.formatDate(value),
      });
      const csvContent = buildCsvDataUri(csvRows);
      this.triggerCsvDownload(csvContent, 'request_list.csv');
    },
    /**
     * Handle header visibility updates from RequestListTable
     * Supports both single item toggle (legacy) and full array replacement (CustomizeColumnMenu)
     * @param {Object|Array} payload - Single header item or full headers array
     */
    addTableHeader(payload) {
      if (Array.isArray(payload)) {
        // Full array replacement from CustomizeColumnMenu
        this.tableheaders = payload;
      } else {
        // Single item toggle (legacy behavior)
        this.tableheaders.find((x) => x === payload ? x.visible = !x.visible : "");
      }
    },
    setPaginatedData(paginationInfo) {
      if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
        this.paginatedItems = paginationInfo.data || [];
        this.currentPage = paginationInfo.page || 1;
      } else {
        this.paginatedItems = paginationInfo || [];
      }
    },
    select(isSelected) {
      if (isSelected) {
        // Select all items across all pages from the full filtered dataset
        this.selectItem = this.requestlistCopy.map(item => item._id);
      } else {
        this.selectItem = [];
      }
    },
    /**
     * Apply filter criteria to the request list
     * Stores filter state to reapply after data updates
     * Considers active stage filter from summary cards
     * @param {Object} item - Filter criteria object
     * @param {Object} header - Header information
     */
    filterPart(item, header) {
      console.log('[InformationManager]: filterPart', item, header);
      // Save filter criteria for reapplication after store updates
      this.activeFilter = { item: JSON.parse(JSON.stringify(item)), header };
      // Sync selectfilter to keep DataTableAction UI in sync
      this.selectfilter = JSON.parse(JSON.stringify(item));
      
      // Start with stage-filtered data if stage filter is active
      let baseList = this.requestlist ? JSON.parse(JSON.stringify(this.requestlist)) : [];
      // Enrich with computed fields (e.g. duedate_days) needed for number-range filters
      this.enrichRequestList(baseList);
      if (this.selectedTab !== null) {
        baseList = baseList.filter(req => req.stage === this.selectedTab);
      }
      
      // Apply column filter on top of stage-filtered data
      const filtered = this.$nova.filterByDynamicCriteria(baseList, item);
      this.requestlistCopy = filtered;
      // Reset to first page when applying new filter
      this.currentPage = 1;
    },
    /**
     * Clear active filters and reset to show all requests from state
     * @param {Object} item - Clear filter event data
     */
    clearPart(item) {
      console.log('[InformationManager]: clearPart', item);
      // Clear saved filter criteria
      this.activeFilter = null;
      // Clear selectfilter to reset DataTableAction UI
      this.selectfilter = {};
      // Reset to show all requests considering current stage filter
      this.applyStageFilter(this.selectedTab);
      // Reset to first page when clearing filters
      this.currentPage = 1;
    },
    /**
     * Apply stage-based filter to the request list
     * Filters requests by the stage field when a summary card is clicked
     * @param {number|null} stage - Stage value to filter by (null shows all)
     */
    applyStageFilter(stage) {
      console.log(LOG_PREFIX, 'applyStageFilter', stage);
      let filteredList = this.requestlist ? JSON.parse(JSON.stringify(this.requestlist)) : [];
      // Enrich with computed fields (e.g. duedate_days) needed for number-range filters
      this.enrichRequestList(filteredList);
      
      // Apply stage filter if a specific stage is selected
      if (stage !== null) {
        filteredList = filteredList.filter(item => item.stage === stage);
      }
      
      // Apply active column filter if present
      if (this.activeFilter) {
        filteredList = this.$nova.filterByDynamicCriteria(filteredList, this.activeFilter.item);
      }
      
      this.requestlistCopy = filteredList;
      // Reset to first page when applying new stage filter
      this.currentPage = 1;
      
      // Update pagination component
      this.$nextTick(() => {
        if (this.$refs.paginationComponent) {
          this.$refs.paginationComponent.page = 1;
          this.$refs.paginationComponent.emitPaginatedData();
        }
      });
    },
    async summaryEmailSend() {
      this.summaryEmailLoading = true;
      try {
        const [suggestions] = await Promise.all([
          this.fetchEmailSuggestions({ projectId: this.id }),
          this.$store.dispatch('informationManager/fetchEmailTemplate'),
        ]);
        this.emailSuggestions = suggestions;
      } catch (e) {
        console.error(LOG_PREFIX, 'Failed to fetch email suggestions', e);
        this.emailSuggestions = [];
      } finally {
        this.summaryEmailLoading = false;
      }
      this.summaryEmailDialog = true;
    },
    async sendSummaryEmail(emailData) {
      this.summaryEmailLoading = true;
      try {
        const result = await this.triggerEmailSummary({
          projectId: this.id,
          selectedItems: emailData.selectedItems,
          to: emailData.to,
          cc: emailData.cc,
          body: emailData.body,
          subject: emailData.subject,
        });
        if (result === 'success') {
          this.summaryEmailDialog = false;
        }
      } catch (err) {
        console.error(LOG_PREFIX, 'sendSummaryEmail error', err);
      } finally {
        this.summaryEmailLoading = false;
      }
    },
    async sendfollowUP(item) {
        this.loading = true;
        try {
          let data = [{ info_owner: [item.info_owner], type: "reminder" }];
          await this.$store.dispatch('pbc/sendPbcMail', { id: this.id, data });
          // fetchRequests is called by the action (if pbc action calls it)
          this.$store.commit("sbSuccess", "Follow-up mail sent successfully");
        } catch (err) {
          const errorMsg = this.$store.state.pbc.sendMailError || err.message || "Unknown error!";
          this.$store.commit("sbError", errorMsg);
          console.log(err);
        } finally {
          this.loading = false;
        }
    },
  },
  watch: {
    '$route.params.id'(nextId) {
      if (nextId && nextId !== this.routeProjectId) {
        this.initializeComponent();
      }
    },
    "$store.state.client": function () {
      this.refreshData();
    },
    "$route": function (d) {
      if (d.hash === "#add") this.addNewRequest();
    },
    "addrequestdialog": function (d) {
      if (!d) this.$nova.gotoLink({ hash: '' });
    },
    /**
     * Watch selectedTab to filter requests by stage when a summary card is clicked
     * Applies stage-based filtering and resets pagination
     */
    selectedTab(stage) {
      this.applyStageFilter(stage);
    },
    // Reapply filters when store data updates
    requestlist: {
      handler(newList) {        
        const savedPage = this.currentPage;
        // Update the location filterLabelMap on the header whenever the list changes
        this.updateLocationLabelMap();

        // Apply stage filter first, then any active column filter
        let filteredList = newList ? JSON.parse(JSON.stringify(newList)) : [];
        // Enrich with computed fields (e.g. duedate_days) needed for number-range filters
        this.enrichRequestList(filteredList);
        
        // Apply stage filter if selectedTab is set
        if (this.selectedTab !== null) {
          filteredList = filteredList.filter(item => item.stage === this.selectedTab);
        }
        
        if (this.activeFilter) {
          // Reapply active filter to already stage-filtered data
          this.requestlistCopy = this.$nova.filterByDynamicCriteria(filteredList, this.activeFilter.item);
          // Ensure selectfilter is synced to maintain DataTableAction UI state after data refresh
          if (JSON.stringify(this.selectfilter) !== JSON.stringify(this.activeFilter.item)) {
            this.selectfilter = JSON.parse(JSON.stringify(this.activeFilter.item));
          }
          // Restore pagination position after filter reapplication
          this.$nextTick(() => {
            if (this.$refs.paginationComponent) {
              // Calculate max pages for filtered results
              const maxPages = Math.ceil(this.requestlistCopy.length / this.itemsPerPage);
              // If saved page is beyond available pages or if only 1 page of results, go to page 1
              if (maxPages <= 1 || savedPage > maxPages) {
                this.$refs.paginationComponent.page = 1;
              } else if (savedPage > 1) {
                this.$refs.paginationComponent.page = savedPage;
              }
              this.$refs.paginationComponent.emitPaginatedData();
            }
          });
        } else {
          // No active column filter, use stage-filtered data
          this.requestlistCopy = filteredList;
        }
      },
      deep: true
    }
  },
};
</script>

<style>
/* .pbc-view-table .sl-no{
      max-width: 30px !important;
    } */
.response-td {
  max-width: 300px !important;
}

.response-td .response-td-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>

<style lang="scss" scoped>
[data-testid="project-view-new__summary-panel"] {
  padding-bottom: 12px;
}

.btnsize{
  font-size: 20px !important;
}
</style>
